import { render, staticRenderFns } from "./pubuliuCard.vue?vue&type=template&id=d60d11fa&scoped=true"
import script from "./pubuliuCard.vue?vue&type=script&lang=js"
export * from "./pubuliuCard.vue?vue&type=script&lang=js"
import style0 from "./pubuliuCard.vue?vue&type=style&index=0&id=d60d11fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60d11fa",
  null
  
)

export default component.exports